import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=b19e53b2&scoped=true&"
import script from "./DetailList.vue?vue&type=script&lang=ts&"
export * from "./DetailList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19e53b2",
  null
  
)

export default component.exports